import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Guid } from "guid-typescript";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { PaymentDetailResponse } from "../models/payment";

@Injectable({
  providedIn: "root",
})
export class PaymentService {
  private paymentUrl = "payment";

  constructor(private http: HttpClient) {}

  getSummaryPayment(id: Guid): Observable<PaymentDetailResponse> {
    return this.http.get<PaymentDetailResponse>(environment.apiConfig.uri + this.paymentUrl + "/" + id + "/summary");
  }
}
